// extracted by mini-css-extract-plugin
export default {"content":"MainContent_content__UUeVo","subTitle":"MainContent_subTitle__K1Eqs","rtl":"MainContent_rtl__5g7F5","text":"MainContent_text__0w+UH"};